// // src/store.js
// import { configureStore } from "@reduxjs/toolkit";
// import { persistStore, persistReducer } from "redux-persist";
// import storageSession from "redux-persist/lib/storage/session"; // Gunakan sessionStorage
// import { combineReducers } from "redux";
// import { thunk } from "redux-thunk"; // middleware async

// // Reducer modules
// import LayoutReducer from "./slices/layouts/reducer";
// import LoginReducer from "./slices/auth/login/reducer";
// import AccountReducer from "./slices/auth/register/reducer";
// import ProfileReducer from "./slices/auth/profile/reducer";
// import CalendarReducer from "./slices/calendar/reducer";
// import ChatReducer from "./slices/chat/reducer";
// import EcommerceReducer from "./slices/ecommerce/reducer";

// // Gabungkan semua slice reducer
// const rootReducer = combineReducers({
//   Layout: LayoutReducer,
//   Login: LoginReducer,
//   Account: AccountReducer,
//   Profile: ProfileReducer,
//   Calendar: CalendarReducer,
//   Chat: ChatReducer,
//   Ecommerce: EcommerceReducer,
// });

// // Konfigurasi persist
// const persistConfig = {
//   key: "root",
//   storage: storageSession, // Gunakan sessionStorage
//   whitelist: ["Login"], // Hanya state Login yang disimpan
// };

// // Bungkus rootReducer dengan persistReducer
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Konfigurasi store
// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false, // penting agar tidak error karena redux-persist
//     }).concat(thunk), // middleware async opsional (sudah default, tapi eksplisit juga oke)
// });

// // Konfigurasi persistor untuk <PersistGate />
// export const persistor = persistStore(store);

// // Ekspor store default
// export default store;

// src/store.js
// //-------------------
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { combineReducers } from 'redux';

// Reducers
import LayoutReducer from './slices/layouts/reducer';
import LoginReducer from './slices/auth/login/reducer';
import AccountReducer from './slices/auth/register/reducer';
import ProfileReducer from './slices/auth/profile/reducer';
import CalendarReducer from './slices/calendar/reducer';
import ChatReducer from './slices/chat/reducer';
import EcommerceReducer from './slices/ecommerce/reducer';
import encryptTransform from './utils/encryptTransform';
import decryptTransform from './utils/decryptTransform';

// Root reducer
const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  Profile: ProfileReducer,
  Calendar: CalendarReducer,
  Chat: ChatReducer,
  Ecommerce: EcommerceReducer,
});

// Persist config
const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['Login', 'Account', 'Profile'],
  transforms: [encryptTransform, decryptTransform],
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Persistor
export const persistor = persistStore(store);
export default store;

// // src/store.js
// import { configureStore } from "@reduxjs/toolkit";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // Ganti ke localStorage
// import { combineReducers } from "redux";

// // Reducers
// import LayoutReducer from "./slices/layouts/reducer";
// import LoginReducer from "./slices/auth/login/reducer";
// import AccountReducer from "./slices/auth/register/reducer";
// import ProfileReducer from "./slices/auth/profile/reducer";
// import CalendarReducer from "./slices/calendar/reducer";
// import ChatReducer from "./slices/chat/reducer";
// import EcommerceReducer from "./slices/ecommerce/reducer";

// // Gabungkan semua slice reducer
// const rootReducer = combineReducers({
//   Layout: LayoutReducer,
//   Login: LoginReducer,
//   Account: AccountReducer,
//   Profile: ProfileReducer,
//   Calendar: CalendarReducer,
//   Chat: ChatReducer,
//   Ecommerce: EcommerceReducer,
// });

// // Konfigurasi persist
// const persistConfig = {
//   key: "root",
//   storage, // menggunakan localStorage
//   whitelist: ["Login"], // hanya Login state yang disimpan
// };

// // Reducer dengan persist
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Store
// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false, // untuk menghindari error redux-persist
//     }),
// });

// // Persistor
// export const persistor = persistStore(store);
